import { render, staticRenderFns } from "./AddInfo.vue?vue&type=template&id=0afea03a&"
import script from "./AddInfo.vue?vue&type=script&lang=js&"
export * from "./AddInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports